import As24AuthorizationDialog, { AuthorizationCanceledError } from '@/components/base/As24AuthorizationDialog';
import { Defer } from '@/util/helper';

export { AuthorizationCanceledError };

export default {
	data: () => ({
		authorizeAs24Defer: null,
		authorizeAs24Running: false,
	}),
	extendRender() {
		const render = this.$options.render;
		return () => {
			const vnode = render.call(this);

			const dialog = this.$createElement(As24AuthorizationDialog, {
				attrs: {
					defer: this.authorizeAs24Defer,
					open: this.authorizeAs24Running,
				},
				on: {
					'update:open': ($event) => {
						this.authorizeAs24Running = $event;
					},
				},
			});

			vnode.componentOptions.children = vnode.componentOptions.children || [];
			vnode.componentOptions.children.push(dialog);
			dialog.parent = vnode;

			return vnode;
		};
	},
	created() {
		this.$options.render = this.$options.extendRender.call(this);
	},
	methods: {
		authorizeAs24() {
			this.authorizeAs24Defer = new Defer();
			this.authorizeAs24Running = true;

			return this.authorizeAs24Defer.promise;
		},
	},
};
